export default {
  DAY_FORMAT: 'DD/MM/YYYY',
  HOUR_DAY_FORMAT: 'DD/MM/YYYY hh:mm ',
};
